module.exports = __webpack_public_path__ + "static/media/lgi-logo.1b23c822.png";